const ifStickySupport = function() {
  let prop = "position:",
    value = "sticky",
    el = document.createElement("test"),
    mStyle = el.style;

  mStyle.cssText =
    prop +
    ["-webkit-", "-moz-", "-ms-", "-o-", ""].join(value + ";" + prop) +
    value +
    ";";

  return mStyle["position"].indexOf(value) !== -1;
};

export default ifStickySupport;
